const scheduleActions = {
  updateAppointment: (payload) => (dispatch, getState) => { 
    dispatch({ type: 'UPDATE_APPOINTMENT_KEY', payload})
  },
  updateAppointmentFromSS: (data) => (dispatch, getState) => dispatch({type: 'APPOINTMENT_FROM_SS', payload: data}),
  clearAppointmentSS: () => (dispatch, getState) => dispatch({type: 'EMPTY_SS'})
}
 
export default scheduleActions
